module.exports = __webpack_public_path__ + "assets/img/logo-wh.24a53159.svg";